import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';

export const Disclaimer = (props) => {
  const { disclaimerInfo, i18n, permissions } = props;
  const showAdvancedInformation = permissions && permissions.dynamic && permissions.dynamic.SearchCampaignCreationRevamp;

  if (!_.isEmpty(disclaimerInfo)) {
    if (disclaimerInfo.DisclaimerLayout === 'Popup') {
      return (
        <p className="disclaimer-text">
          {showAdvancedInformation ?
            i18n.getString(_TL_('Campaign level disclaimer: {{name}}'), { name: disclaimerInfo.Name }) :
            i18n.getString(_TL_('Campaign level disclaimer'))}
        </p>
      );
    }
    if (disclaimerInfo.DisclaimerLayout === 'AdditionalLine') {
      return (
        <p className="disclaimer-text">
          {showAdvancedInformation ?
            i18n.getString(_TL_('Campaign level disclaimer: {{name}}\n(Note: Additional line layout disclaimers will not have description 2.)'), { name: disclaimerInfo.Name }) :
            i18n.getString(_TL_('Campaign level disclaimer (Note: Additional line layout disclaimers will not have description 2.)'))}
        </p>
      );
    }
  }
  return null;
};

Disclaimer.propTypes = {
  disclaimerInfo: PropTypes.shape({
    DisclaimerLayout: PropTypes.string,
    Name: PropTypes.string,
  }),
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      SearchCampaignCreationRevamp: PropTypes.bool,
    }),
  }),
};

Disclaimer.defaultProps = {
  disclaimerInfo: null,
  permissions: {
    dynamic: {
      SearchCampaignCreationRevamp: false,
    },
  },
};
